<div class="page-wrapper">
    <div class="page-header list-page-header mb-3">

        <div class="d-flex align-items-center gap-3">

            <button (click)="back()" class="btn-white">
                <svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M6.67969 3.1737H1.41258L3.55632 5.07945L3.09831 5.48945L0.165782 2.8853L3.09831 0.27832L3.55632 0.688311L1.41258 2.59406H6.67969V3.1737Z"
                        fill="#052B63" />
                </svg>
                Back
            </button>
            <h4 class="page-title ">MARKET ASSET</h4>
        </div>

        <div class="tab-actions py-1">
            <div class="d-flex gap-2 align-items-center flex-wrap">
                <div cklass="search-container">
                    <div class="amc-search-bar" (click)="toggleShowSearch()">
                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M15.2094 13.7386L12.9178 11.4981L12.8641 11.4164C12.7643 11.317 12.6277 11.261 12.4852 11.261C12.3426 11.261 12.2061 11.317 12.1062 11.4164C10.1587 13.2031 7.15783 13.3002 5.09373 11.6434C3.02964 9.98651 2.54284 7.08981 3.95619 4.87434C5.36953 2.65888 8.24444 1.81213 10.6743 2.89565C13.1041 3.97918 14.3349 6.65676 13.5504 9.15262C13.4939 9.33293 13.5401 9.52901 13.6716 9.66701C13.803 9.805 13.9998 9.86394 14.1878 9.82162C14.3757 9.7793 14.5263 9.64216 14.5828 9.46185C15.5207 6.49999 14.1042 3.3126 11.2498 1.9616C8.39539 0.610603 4.95962 1.50144 3.1651 4.05784C1.37058 6.61423 1.75585 10.069 4.07168 12.1872C6.38752 14.3055 9.93892 14.4515 12.4285 12.5308L14.4575 14.5146C14.6671 14.7186 15.0058 14.7186 15.2154 14.5146C15.4247 14.3077 15.4247 13.9746 15.2154 13.7678L15.2094 13.7386Z"
                                fill="#667085" />
                        </svg>
                        <span>Search</span>
                    </div>
                </div>

                <button class="custom-btn-primary">
                    ADD MARKET LINE
                </button>
            </div>

            
        </div>
    </div>



    <div class="panel-div">

        <form class="search-form" [formGroup]="form" *ngIf="showSearchForm">

            <div class="row mt-2 g-3">
                <div class="col-md-4">
                    <div class="field">
                        <label for="" class="form-label">Phone Number</label>
                        <input type="tel" class="form-control" formControlName="phoneNumber" [maxlength]="20" />
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="field">
                        <label for="" class="form-label">Plate Number</label>
                        <input type="text" class="form-control" formControlName="plateNumber" [maxlength]="20" />
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="field">
                        <label for="" class="form-label">Market Code</label>
                        <input type="text" class="form-control" formControlName="MCode" [maxlength]="20" />
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="field">
                        <label for="" class="form-label">Market Line</label>
                        <input type="text" class="form-control" formControlName="marketLine" [maxlength]="20" />
                    </div>
                </div>


                <div class="col-md-4">
                    <div class="field">
                        <label for="" class="form-label">Route</label>
                        <input type="text" class="form-control" formControlName="route" [maxlength]="20" />
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="field">
                        <label for="" class="form-label">Start Date</label>
                        <input type="date" class="form-control" formControlName="startDate" [maxlength]="20" />
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="field">
                        <label for="" class="form-label">End Date</label>
                        <input type="date" class="form-control" formControlName="endDate" [maxlength]="20" />
                    </div>
                </div>


            </div>

            <span class="material-symbols-outlined text-danger" style="position: absolute; top: 5px; right: 10px;"
                role="button" (click)="toggleShowSearch()">close</span>


            <div class="actions d-flex align-items-end">
                <span class="clear-all-btn" role="button" (click)="clearSearchFilters()">Clear all filters</span>

                <button class="custom-btn-primary search-button ms-auto"
                    (click)="search(); toggleShowSearch()">Search</button>

            </div>
        </form>

        <div class="table-wrapper border-radius-full">
            <table class="role-table amc-table" appAutoDataLabel>
                <thead class="amc-table-heading">
                    <tr>
                        <th>S/N</th>
                        <th>Market ID</th>
                        <th>Taxpayer Name</th>
                        <th>Market (Line)</th>
                        <th>Shop No</th>
                        <th>Date Registered</th>
                        <th class="text-center">Action</th>
                    </tr>
                </thead>

                <tbody>
                    @if(isLoading || isSearching){
                    <tr class="border-0 tr-table-loader">
                        <td [colSpan]="7" class="td-table-loader">
                            <app-bounce-loader></app-bounce-loader>
                        </td>
                    </tr>
                    } @else {
                    @if(!searchedDataNotFound){
                        <tr *ngFor="let item of dataList; let i = index">
                            <td>{{ i + (currentPage -1) + 1 }}</td>
                            <td>{{ item?.marketId  }}</td>
                            <td>{{ item?.taxpayerName || '--' | titlecase}}</td>
                            <td>{{ item?.marketLine || '--' }}</td>
                            <td>{{ item?.shopNumber || '--' }}</td>
                            <td>{{ item?.createdAt | date}}</td>
    
                            <td data-label="Action">
                                <div class="amc-table-action-wrapper">
                                    <span class="material-symbols-outlined action-icon" data-bs-toggle="dropdown">
                                        more_horiz
                                    </span>
                                    <div class="dropdown-menu amc-table-action-select">
                                        <div class="dropdown-wrapper"> 
                                            <div class="action-btn" role="button"
                                                (click)="viewTaxpayer(item?.id); $event.stopPropagation()">
                                                View Details
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
    
                            <!-- <td>
                    <div class="amc-table-action-wrapper">
                      <button class="custom-btn-primary"
                        style="height: 20px; font-size: 13px; padding: 12px 15px; border-radius: 4px;"
                        *ngIf="item?.assignStatus == 'UN_ASSIGNED' && item?.soldStatus != 'SOLD'" role="button">
                        Revoke
                      </button>
                    </div>
                  </td> -->
                        </tr>
                    } @else{
                    <tr class="tr-empty-placeholder">
                        <td colspan="5" class="text-center">No results found</td>
                    </tr>
                    }
                    }
                </tbody>
            </table>


        </div>




    </div>

    <div class="d-flex justify-content-between align-items-center mt-2 flex-wrap">

        <div class="d-flex align-items-center me-4">
            <div>Rows per page: </div>
            <div class="mx-2">
                <select class="form-control px-6 text-center" style="width: auto; min-width: 40px;"
                    [(ngModel)]="selectedLimit" (change)="updateLimit()">
                    <option [value]=5>5</option>
                    <option [value]=10>10</option>
                    <option [value]=20>20</option>
                    <option [value]=30>30</option>
                    <option [value]=40>40</option>
                    <option [value]=50>50</option>

                </select>
            </div>
        </div>


        <div class="pagination-container">
            <ngb-pagination *ngIf="!isSearching && count > 0" [(page)]="currentPage" (pageChange)="callDb($event)"
                [maxSize]="5" [pageSize]="pageSize" [collectionSize]="count" [boundaryLinks]="true"
                [directionLinks]="true" [rotate]="true" class="pagination justify-content-center my-3">
            </ngb-pagination>
        </div>
    </div>
</div>